<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-3/4 h-3/4 mx-auto bg-white border rounded-lg"
  >
    <div class="p-6">
      <div class="pb-4 text-xl">{{ title }}</div>

      <ul class="generic-list-modal__list">
        <li
          v-for="(item, index) in items"
          :key="itemKey(item, index)"
          class="generic-list-modal__item"
        >
          <a
            v-if="itemUrl(item)"
            :href="itemUrl(item)"
            :target="linkTarget(itemUrl(item))"
            v-bind="linkRelAttrs(itemUrl(item))"
            class="text-blue-600 hover:text-blue-700 underline"
          >{{ itemLabel(item) }}</a>
          <span v-else>{{ itemLabel(item) }}</span>
        </li>
      </ul>

      <button class="pad btn btn-primary float-right" type="button" @click="closeModal()">Close</button>

      <div class="h-10">&nbsp;</div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { VueFinalModal } from 'vue-final-modal'
  import { computed } from 'vue'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  const title = computed(() => props.params?.data?.title ?? '')
  const items = computed(() => {
    const raw = props.params?.data?.items
    return Array.isArray(raw) ? raw : []
  })

  function closeModal() {
    emit('close')
  }

  function itemKey(item, index) {
    if (item && typeof item === 'object' && item.id != null) return String(item.id)
    const u = itemUrl(item)
    if (u) return `${u}-${index}`
    return index
  }

  function itemUrl(item) {
    if (item == null) return ''
    if (typeof item === 'string') return ''
    const u = item.url ?? item.href
    return typeof u === 'string' && u.trim() !== '' ? u.trim() : ''
  }

  function itemLabel(item) {
    if (item == null) return ''
    if (typeof item === 'string') return item
    const label = item.text ?? item.label ?? item.title ?? item.name
    if (label != null && String(label) !== '') return String(label)
    const u = itemUrl(item)
    return u || ''
  }

  function linkTarget(url) {
    return /^https?:\/\//i.test(url) ? '_blank' : '_self'
  }

  function linkRelAttrs(url) {
    if (linkTarget(url) !== '_blank') return {}
    return { rel: 'noopener noreferrer' }
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }
  .generic-list-modal__list {
    list-style: disc;
    padding-left: 1.5rem;
    margin: 0 0 1rem;
  }
  .generic-list-modal__item {
    padding: 6px 0;
  }
</style>
